export default {
  allowButton: false,
  allowHeading: false,
  allowSocial: false,
  allowSubheading: false
};